import ContactUs from 'components/ContactUs/ContactUs';
import WhyWorkersChooseJoblio from 'components/HeroComponents/WhyWorkersChooseJoblio';
import MediaSection from 'components/MediaSection/MediaSection';
import OurCLients from 'components/OurCLients/OurCLients';
import SplitScreen from 'components/SplitScreen';
import Testimonials from 'components/Testimonials/Testimonials';

const Home = () => {
  return (
    <>
      <SplitScreen />
      <WhyWorkersChooseJoblio
        componentToShowOnMobile={<OurCLients />}
        backgroundColor="--brand-primary-lighten"
        highlightColor="blue"
      />
      <MediaSection />
      <Testimonials />
      <ContactUs />
    </>
  );
};

export default Home;
